<template>
    <div class="sa-tab-scroll">
        <b-card v-if="isEquilibrioSeduto" class="sa-card sa-card-border" header="EQUILIBRIO DA SEDUTO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaEquilibrioSeduto" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isAlzarsiSedia" class="sa-card sa-card-border" header="ALZARSI DALLA SEDIA" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaAlzarsiSedia" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isTentativoAlzarsi" class="sa-card sa-card-border" header="TENTATIVO DI ALZARSI" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaTentativoAlzarsi" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isEquilibrioStazioneEretta" class="sa-card sa-card-border" header="EQUILIBRIO STAZIONE ERETTA" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaEquilibrioStazioneEretta" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isEquilibrioStazioneErettaProlungata" class="sa-card sa-card-border" header="EQUILIBRIO STAZIONE ERETTA PROLUNGATA" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaEquilibrioStazioneErettaProlungata" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isRomberg" class="sa-card sa-card-border" header="ROMBERG" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaRomberg" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isRombergSensibilizzato" class="sa-card sa-card-border" header="ROMBERG SENSIBILIZZATO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaRombergSensibilizzato" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isGirarsi" class="sa-card sa-card-border" header="GIRARSI DI 360°" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaGirarsi" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isSedersi" class="sa-card sa-card-border" header="SEDERSI" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaSedersi" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isInizioDeambulazione" class="sa-card sa-card-border" header="INIZIO DELLA DEAMBULAZIONE" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaInizioDeambulazione" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isLunghezzaPassoDx" class="sa-card sa-card-border" header="LUNGHEZZA PASSO (PIEDE DX)" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaLunghezzaPassoPiedeDx" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isAltezzaPassoDx" class="sa-card sa-card-border" header="ALTEZZA PASSO(PIEDE DX)" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaAltezzaPassoPiedeDx" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isLunghezzaPassoSx" class="sa-card sa-card-border" header="LUNGHEZZA PASSO (PIEDE SX)" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaLunghezzaPassoPiedeSx" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isAltezzaPassoSx" class="sa-card sa-card-border" header="ALTEZZA PASSO(PIEDE SX)" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaAltezzaPassoPiedeSx" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isSimmetriaPasso" class="sa-card sa-card-border" header="SIMMETRIA DEL PASSO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaSimmetriaPasso" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isContinuitaPasso" class="sa-card sa-card-border" header="CONTINUITA' DEL PASSO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaContinuitaPasso" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isTraiettoria" class="sa-card sa-card-border" header="TRAIETTORIA" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaTraiettoria" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isCammino" class="sa-card sa-card-border" header="CAMMINO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaCammino" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card v-if="isTronco" class="sa-card sa-card-border" header="TRONCO" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="sm" striped hover :items="listaTronco" :fields="fieldsListe" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header"> </b-table>
        </b-card>
        <b-card class="sa-card sa-card-border" header="Totale" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <span class="sa-label-data">{{ totale }}</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";
export default {
    components: {},
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    watch: {},
    data() {
        return {
            idAccettazione: null,
            keyPropostaAccesso: 0,
            linkback: "",
            linkPrintData: "",
            childKey: 0,
            pathResource: "/rsascalatinettirichieste",
            totale: 0,
            isAlzarsiSedia: false,
            isEquilibrioSeduto: false,
            isTentativoAlzarsi: false,
            isAltezzaPassoDx: false,
            isAltezzaPassoSx: false,
            isCammino: false,
            isContinuitaPasso: false,
            isEquilibrioStazioneEretta: false,
            isEquilibrioStazioneErettaProlungata: false,
            isGirarsi: false,
            isInizioDeambulazione: false,
            isLunghezzaPassoDx: false,
            isLunghezzaPassoSx: false,
            isRomberg: false,
            isRombergSensibilizzato: false,
            isSedersi: false,
            isSimmetriaPasso: false,
            isTraiettoria: false,
            isTronco: false,
            jsonData: [],
            listaEquilibrioSeduto: [],
            listaAlzarsiSedia: [],
            listaTentativoAlzarsi: [],
            listaEquilibrioStazioneEretta: [],
            listaEquilibrioStazioneErettaProlungata: [],
            listaRomberg: [],
            listaContinuitaPasso: [],
            listaRombergSensibilizzato: [],
            listaGirarsi: [],
            listaSedersi: [],
            listaInizioDeambulazione: [],
            listaLunghezzaPassoPiedeDx: [],
            listaAltezzaPassoPiedeDx: [],
            listaLunghezzaPassoPiedeSx: [],
            listaAltezzaPassoPiedeSx: [],
            listaSimmetriaPasso: [],
            listaTraiettoria: [],
            listaCammino: [],
            listaTronco: [],
            fieldsListe: [
                {
                    label: "Descrizione",
                    key: "fattore",
                    sortable: true,
                },
                // {
                //     label: "",
                //     key: "check",
                //     sortable: true,
                //     thStyle: "width: 10rem",
                //     tdClass: "text-center sa-column-widh",
                // },
                // {
                //   label: "",
                //   key: "action",
                //   thStyle: "width: 10rem",
                // },
            ],
        };
    },
    mounted() {
        let me = this;
        if (this.$route.params.id) {
            me.idAccettazione = this.$route.params.id;
        } else {
            me.idAccettazione = this.$route.query.idPaziente;
        }
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/richiesta/" + me.idAccettazione;
            me.isAlzarsiSedia = false;
            me.isEquilibrioSeduto = false;
            me.isTentativoAlzarsi = false;
            me.isAltezzaPassoDx = false;
            me.isAltezzaPassoSx = false;
            me.isCammino = false;
            me.isContinuitaPasso = false;
            me.isEquilibrioStazioneEretta = false;
            me.isEquilibrioStazioneErettaProlungata = false;
            me.isGirarsi = false;
            me.isInizioDeambulazione = false;
            me.isLunghezzaPassoDx = false;
            me.isLunghezzaPassoSx = false;
            me.isRomberg = false;
            me.isRombergSensibilizzato = false;
            me.isSedersi = false;
            me.isSimmetriaPasso = false;
            me.isTraiettoria = false;
            me.isTronco = false;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data.list;
                    me.calcolaPunteggio();
                    me.jsonData.forEach((element) => {
                        if (element.check) {
                            me.jsonData.push({ idRichiesta: me.idAccettazione, idScalaTinetti: element.id });
                            switch (element.gruppo) {
                                case "EQUILIBRIO DA SEDUTO":
                                    me.isEquilibrioSeduto = true;
                                    me.listaEquilibrioSeduto.push(element);
                                    break;
                                case "ALZARSI DALLA SEDIA":
                                    me.isAlzarsiSedia = true;
                                    me.listaAlzarsiSedia.push(element);
                                    break;
                                case "TENTATIVO DI ALZARSI":
                                    me.isTentativoAlzarsi = true;
                                    me.listaTentativoAlzarsi.push(element);
                                    break;
                                case "EQUILIBRIO STAZIONE ERETTA":
                                    me.isEquilibrioStazioneEretta = true;
                                    me.listaEquilibrioStazioneEretta.push(element);
                                    break;
                                case "EQUILIBRIO STAZIONE ERETTA PROLUNGATA":
                                    me.isEquilibrioStazioneErettaProlungata;
                                    me.listaEquilibrioStazioneErettaProlungata.push(element);
                                    break;
                                case "ROMBERG":
                                    me.isRomberg = true;
                                    me.listaRomberg.push(element);
                                    break;
                                case "ROMBERG SENSIBILIZZATO":
                                    me.isRombergSensibilizzato = true;
                                    me.listaRombergSensibilizzato.push(element);
                                    break;
                                case "GIRARSI DI 360":
                                    me.isGirarsi = true;
                                    me.listaGirarsi.push(element);
                                    break;
                                case "SEDERSI":
                                    me.isSedersi = true;
                                    me.listaSedersi.push(element);
                                    break;
                                case "INIZIO DELLA DEAMBULAZIONE":
                                    me.isInizioDeambulazione = true;
                                    me.listaInizioDeambulazione.push(element);
                                    break;
                                case "LUNGHEZZA PASSO (PIEDE DX)":
                                    me.isLunghezzaPassoDx = true;
                                    me.listaLunghezzaPassoPiedeDx.push(element);
                                    break;
                                case "ALTEZZA PASSO (PIEDE DX)":
                                    me.isAltezzaPassoDx = true;
                                    me.listaAltezzaPassoPiedeDx.push(element);
                                    break;
                                case "LUNGHEZZA PASSO (PIEDE SX)":
                                    me.isLunghezzaPassoSx = true;
                                    me.listaLunghezzaPassoPiedeSx.push(element);
                                    break;
                                case "ALTEZZA PASSO (PIEDE SX)":
                                    me.isLunghezzaPassoSx = true;
                                    me.listaAltezzaPassoPiedeSx.push(element);
                                    break;
                                case "SIMMETRIA DEL PASSO":
                                    me.isSimmetriaPasso = true;
                                    me.listaSimmetriaPasso.push(element);
                                    break;
                                case "CONTINUITA' DEL PASSO":
                                    me.isContinuitaPasso = true;
                                    me.listaContinuitaPasso.push(element);
                                    break;
                                case "TRAIETTORIA":
                                    me.isTraiettoria = true;
                                    me.listaTraiettoria.push(element);
                                    break;
                                case "CAMMINO":
                                    me.isCammino = true;
                                    me.listaCammino.push(element);
                                    break;
                                case "TRONCO":
                                    me.isTronco = true;
                                    me.listaTronco.push(element);
                                    break;
                            }
                        }
                        // console.log(element.gruppo);
                    });
                })
                .catch(() => {});
        },
        // unisciArray() {
        //     let me = this;
        //     me.jsonData = [];
        //     me.jsonData = me.listaEquilibrioSeduto
        //         .concat(me.listaAlzarsiSedia)
        //         .concat(me.listaTentativoAlzarsi)
        //         .concat(me.listaEquilibrioStazioneEretta)
        //         .concat(me.listaEquilibrioStazioneErettaProlungata)
        //         .concat(me.listaRomberg)
        //         .concat(me.listaContinuitaPasso)
        //         .concat(me.listaRombergSensibilizzato)
        //         .concat(me.listaGirarsi)
        //         .concat(me.listaSedersi)
        //         .concat(me.listaInizioDeambulazione)
        //         .concat(me.listaLunghezzaPassoPiedeDx)
        //         .concat(me.listaAltezzaPassoPiedeDx)
        //         .concat(me.listaLunghezzaPassoPiedeSx)
        //         .concat(me.listaAltezzaPassoPiedeSx)
        //         .concat(me.listaSimmetriaPasso)
        //         .concat(me.listaTraiettoria)
        //         .concat(me.listaCammino)
        //         .concat(me.listaTronco);
        //     let lista = [];

        //     me.jsonData.forEach((element) => {
        //         if (element.check) {
        //             lista.push({ idRichiesta: me.idAccettazione, idScalaTinetti: element.id });
        //         }
        //     });
        //     me.calcolaPunteggio();
        //     //   console.log(lista);
        //     this.$emit("update", lista);
        // },
        calcolaPunteggio() {
            let me = this;
            me.totale = 0;

            me.jsonData.forEach((element) => {
                if (element.check) {
                    let p = element.punteggio >= 0 ? element.punteggio : element.punteggio * -1;
                    me.totale = me.totale + p;
                }
            });
        },

        setListe() {},
    },
};
</script>

<style></style>
